import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './auth/_guards/index'
import { LogoutComponent } from './auth/logout/logout.component'

const routes: Routes = [
  { path: 'login', loadChildren: './auth/auth.module#AuthModule' },
  { path: 'logout', component: LogoutComponent },
  {
    canActivateChild: [AuthGuard],
    path: '',
    pathMatch: 'full',
    redirectTo: 'index'
  }
]

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)]
})
export class AppRoutingModule {}
